import { isFunction } from '@isyscore/utils/type';
import { PROCESS_FAULT_ERR_ORDER } from '../../order-define';
export const errProcess = (options) => {
    const options2 = options || {};
    const { processor, appMessenger } = options2;
    return {
        errOrder: PROCESS_FAULT_ERR_ORDER,
        errInterceptor(err) {
            if (appMessenger) {
                const { status, code } = err;
                if (status === 401) {
                    if (appMessenger.framed) {
                        appMessenger.send('navigator:loginPage');
                    }
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    else if (typeof window.ENVS === 'object') {
                        const returnUrl = encodeURIComponent(location.href);
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        location.assign(window.ENVS.ssoUrl + `?return=${returnUrl}`);
                    }
                    else if (isFunction(processor)) {
                        processor(err);
                    }
                    throw err;
                }
                if (code === 'license.invalid') {
                    appMessenger.send('license:invalid');
                    throw err;
                }
            }
            if (isFunction(processor)) {
                processor(err);
            }
            throw err;
        }
    };
};
